module.exports = require("./../../_gen/starling/display/Stage");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Stage.js
// module id = 174
// module chunks = 0